// 登录域名
const LOGIN_DOMAIN = window._domain_.loginDomain

const goLoginURl = (url) => {
  const newUrl = url.replace(`&target=${encodeURIComponent("开放平台")}`, "");
  const loginUrl = `//${LOGIN_DOMAIN.replace('https://', '')}/sso-proxy-front/#/loginenduser?redirect_uri=${encodeURIComponent(newUrl)}&target=开放平台`;
  return loginUrl;
}

export default {
  goLoginURl: goLoginURl,
  // 是否是红蓝环境
  isRedBlue: process.env.REACT_APP_WELINK_ENV === 'redBlue',
  createAppUrl: '/wecode/service/open/app', // 创建WeLink应用
  getAllAppsUrl: '/wecode/service/open/apps', // Welink应用列表
  pclogoutUrl: '/sso/v1/pclogout',
  getcodelistUrl: '/wecode/service/open/app/eamap/geteamapcodelist', // 查询EAMAP的应用模块列表
  userInforUrl: '/wecode/service/system/common/initMycData',
  getCurrentRoleUrl: '/wecode/service/open/app/getcurrentrole',
  bindEAMAPUrl: '/wecode/service/open/app/eamap/association', // 应用绑定EAMAP
  getAppBasicInfo: '/wecode/service/open/app', // 应用基本信息查询
  searchAKSKUrl: '/wecode/service/open/app/sk', // 应用凭证查询
  editPropertyUrl: '/wecode/service/open/app/property', // 应用认证方式修改

  getCardList: '/wecode/service/open/app/ability/instances', // 获取对应能力实例列表
  cardOperate: '/wecode/service/open/app/ability/instance', // 卡片操作接口，get：获取详情；post：新增；put：修改；delete：删除

  createApprove: '/wecode/service/open/app/ability/instance/approval-request', // 创建审批
  getCardEflowId: '/wecode/service/open/eflows/get-id-by-resource-id', // 通过实例id获取url审批单id
  recallApprove: '/wecode/service/open/eflow/eflow-status', // 撤回审批
  getTemplateList: '/wecode/service/open/app/card/templates', // 获取模板列表
  
  searchPersonInfo: '/wecode/service/open/app/personinfo', // 单个账号查询
  cardWhitelist: '/wecode/service/open/app/ability/instance/whitelist', // 可见范围查询和更新
  importExcelFile: '/wecode/service/open/app/ability/instance/whitelist/import', // 导入上传文件
  downExcelFile: '/appstore/cardtenant/card/import/result/export/v1', // 下载上传文件

  getMembersListUrl: '/wecode/service/open/app/members', // 应用成员列表分页查询
  deleteMemberUrl: '/wecode/service/open/app/member', // 应用成员单个删除
  transferownerUrl: '/wecode/service/open/app/member/transferowner', // 应用成员owner角色转移
  addMembersUrl: '/wecode/service/open/app/member', // 应用成员添加（支持单个、批量）
  searchMembersUrl: '/wecode/service/open/app/personinfo', // 搜索人员信息（支持新旧工号 姓名）
  getSubscriptionsUrl: '/wecode/service/open/app/permissions-subscriptions', // 应用已开通权限列表查询
  getModulesUrl: '/wecode/service/open/modules', // API权限模块列表查询
  getPermissionsUrl: '/wecode/service/open/app/permissions', // 分页查询当前应用能开通所有权限列表
  openPermissionsUrl: '/wecode/service/open/app/permissions', // 批量开通权限
  getAbilitiesUrl: '/wecode/service/open/app/abilities', // 应用能力列表查询
  addAbilityUrl: '/wecode/service/open/app/ability', // 添加应用能力,
  getabilitiesMenuUrl: '/wecode/service/open/app/abilities-subscriptions', // 已开通能力菜单
  getAppVersions: '/wecode/service/open/app/versions', // 获取应用版本列表
  operationAppVersion: '/wecode/service/open/app/version', // 删除、新增应用版本
  publishAppVersion: '/wecode/service/open/app/version/publish', //应用版本发布
  getAppVersionConfig: '/wecode/service/open/app/version/config', //应用配置项
  getCommonConfig: '/wecode/service/open/common/config', //通用配置
  updateApproveStatus: '/wecode/service/open/eflow/eflow-status', // 更新审批状态
  getEflows: '/wecode/service/open/eflows', //审批列表
  
  complaintList: '/wecode/service/open/report/report-count-list', // 应用投诉列表
  complaintDetailList: '/wecode/service/open/report/report-app-detail-list', // 应用投诉列表详情
  eventsSubscriptions: '/wecode/service/open/app/events-subscriptions', // 已订阅事件列表

  defaultLogoList: '/wecode/service/open/app/default-icons', // 默认应用图片列表
  projectConfigDetial: '/wecode/service/open/app/project/query-detail', // 项目配置页面详情查询
  projectConfigAddOrUpdate: '/wecode/service/open/app/project/add-or-update', // 项目配置新增或修改
  getEntryGroupNoticeTemplate: '/wecode/service/open/app/join-group-notice/templates', // 获取入群通知模板列表
  getEntryGroupNoticeDetail: '/wecode/service/open/app/join-group-notice/query', // 获取入群通知详情
  saveEntryGroupNoticeDetail: '/wecode/service/open/app/join-group-notice/save-or-update', // 保存入群配置详情
  createDistribute: '/wecode/service/open/app/card/${router}/create-distribute', // 新增卡片推送
  uploadImgAction: '/wecode/service/open/app/inner/upload-image', // 图片上传

  getGroupSubscribe: '/wecode/service/open/app/subscribe/list', // 订阅群列表
  getAppCredential: '/wecode/service/open/app/identity', // 获取应用凭证
  getPublishApp: '/wecode/service/open/apps/listed', // 已上架应用列表
};
